<template>
  <div class="base-statistics">
    <div class="base-statistics-form">
      <div class="base-statistics-title">
        <span>地产楼盘：{{ title }}</span>
      </div>
      <div class="base-statistics-time">
        <span>时间：</span>
        <mk-date-picker
          v-model="date"
          size="small"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          @change="handleOnDateChange"
        ></mk-date-picker>
      </div>
    </div>
    <div class="base-statistics-chart">
      <div class="base-statistics-chart-title">
        客户签到排行
      </div>
      <template v-if="data.length">
        <mk-bar
          :options="options"
          :data="data"
        >
        </mk-bar>
      </template>
      <template v-else>
        <no-data></no-data>
      </template>
    </div>
    <div class="base-statistics-detail">
      <mk-radio-group
        v-model="activeName"
        size="small"
        @change="handleOnActiveNameChange"
      >
        <mk-radio-button
          v-for="(radio, index) in radios"
          :key="index"
          :label="radio.name"
        >
          {{ radio.label }}
        </mk-radio-button>
      </mk-radio-group>
      <div class="detail-table">
        <list-table
          :data="tableData"
          :columns="tableColumns"
        >
        </list-table>
      </div>
    </div>
  </div>
</template>

<script>
import ListTable from '@views/smart-name-card/components/list/components/list-table'
import { MKMATERIALSVC } from '@api'
import dayjs from 'dayjs'
export default {
  name: 'BaseStatistics',
  components: {
    ListTable
  },
  data () {
    return {
      activeName: 'staff-detail',
      radios: [{
        label: '员工明细',
        name: 'staff-detail'
      }, {
        label: '驻点明细',
        name: 'arest-point-detail'
      }],
      date: [],
      options: {
        chart: {
          height: 400,
          width: 600
        },
        axis: [
          {
            name: 'name'
          },
          {
            name: 'signInNum'
          }
        ],
        geom: [
          {
            type: 'intervalStack',
            position: 'name*signInNum',
            tooltip: [
              'name*signInNum', (name, signInNum) => {
                return {
                  name: '签到数',
                  value: signInNum
                }
              }
            ],
            size: 60
          }
        ]
      },
      data: [],
      tableData: [],
      tableColumns: []
    }
  },
  computed: {
    title () {
      return this.$route.query.title
    }
  },
  mounted () {
    this.initDate()
    this.estateIndustryStatisticTopTenPost()
    this.estateIndustryStatisticSaleDetailPost()
  },
  methods: {
    handleOnActiveNameChange (name) {
      if (name === 'staff-detail') {
        this.estateIndustryStatisticSaleDetailPost()
      } else {
        this.estateIndustryStatisticPointDetailPost()
      }
    },
    handleOnDateChange (date) {
      this.estateIndustryStatisticTopTenPost()
      this.handleOnActiveNameChange(this.activeName)
    },
    async estateIndustryStatisticTopTenPost () {
      const params = {
        ...this.getDateRange(),
        projectId: this.$route.query.buildId
      }
      const { success, data } = await MKMATERIALSVC.EstateIndustryApi.estateIndustryStatisticTopTenPost(params)
      if (success) {
        this.data = data
      }
    },
    async estateIndustryStatisticSaleDetailPost () {
      const params = {
        ...this.getDateRange(),
        projectId: this.$route.query.buildId
      }
      const { success, data: { data, header } } = await MKMATERIALSVC.EstateIndustryApi.estateIndustryStatisticSaleDetailPost(params)
      if (success) {
        this.tableData = this.getTableData(data, header, 4)
        this.tableColumns = this.getTableHeaders(header, 2)
      }
    },
    async estateIndustryStatisticPointDetailPost () {
      const params = {
        ...this.getDateRange(),
        projectId: this.$route.query.buildId
      }
      const { success, data: { data, header } } = await MKMATERIALSVC.EstateIndustryApi.estateIndustryStatisticPointDetailPost(params)
      if (success) {
        this.tableData = this.getTableData(data, header, 3)
        this.tableColumns = this.getTableHeaders(header, 1)
      }
    },
    getDateRange () {
      return {
        start: this.date[0],
        end: this.date[1]
      }
    },
    initDate () {
      const date = dayjs(new Date()).format('YYYY-MM-DD')
      this.date = [date, date]
    },
    getTableHeaders (header, number) {
      let columns = []
      header.forEach((item, index) => {
        let column = {
          prop: item.id,
          label: item.name,
          showOverflowTooltip: true
        }
        if (index > number) {
          column.sortable = true
        }
        columns.push(column)
      })
      return columns
    },
    getTableData (data, header, index) {
      // cusDistribution 是否为空，若为空，动态字段默认设置为 0
      // 若不为空，将动态字段扁平化处理，与其他字段保持同一级

      data.forEach(item => {
        const cusDistribution = item.cusDistribution
        if (cusDistribution.length > 0) {
          cusDistribution.forEach(element => {
            item[element.id] = element.num
          })
        } else {
          // 获取动态字段 key 值，并设置为 0
          let dynamicKey = header.slice(index, header.length)
          dynamicKey.forEach(key => {
            item[key.id] = 0
          })
        }
      })
      return data
    }
  }
}
</script>

<style lang="scss" scoped>
.base-statistics {
  .base-statistics-form {
    display: flex;
  }

  .base-statistics-title {
    margin-right: 24px;
    margin-bottom: 24px;
    height: 32px;
    line-height: 32px;
  }

  .base-statistics-chart-title {
    margin-bottom: 22px;
    color: #262626;
    font-size: 14px;
    font-weight: 500;
  }

  .detail-table {
    margin-top: 10px;
  }

  .no-data {
    height: 400px;
  }
}
</style>
